<script lang="ts">

    import {MappedConditionOptions} from "../types";
    import {onMount} from "svelte";

    export let condition = 'between';
    export let operator = 'equal';
    export let config: MappedConditionOptions;

    let groupValue = {};

    const groupConfig = (config: MappedConditionOptions) => {
        let result = {};

        config.forEach(c => {
            if (!result.hasOwnProperty(c.group)) {
                result[c.group] = [];
            }

            result[c.group].push(c);
        });

        return result;
    }

    const changeHandler = (e) => {
        let matchedCondition = config.find(c => {
            return c.value === e.target.value;
        });

        if (matchedCondition) {
            condition = matchedCondition.group;
            operator = matchedCondition.operator;
        }
    }

    onMount(() => {
        groupValue = groupConfig(config);
    })
</script>

<select on:input={changeHandler} bind:value={operator}>
	{#each Object.entries( groupValue ) as [key, options]}
		{#if key !== Object.keys( groupValue )[0] }
			<option disabled>————————</option>
		{/if}

		{#each options as option}
			<option value={option.value}>{option.label}</option>
		{/each}
	{/each}
</select>
